/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { format } from 'date-fns';
import { formatDateDDMMYYToYYYYMMDD } from '../../DeliveryCalendarContainer/Partials/CalendarView/helpers/calendarUtility';
import { getCartAttributeByNameAndReturnValue } from '../../../../../../../helpers/page/pageHelpers';

export const isItemPmallProduct = (itemDetails) => {
    if (itemDetails.personalization?.personalizationType === 'EXTERNAL') {
        return true;
    }

    return false;
};

export const getFormatedDeliveryDate = (deliveryDate, formatDeliveryDate = 'eeee, MMM dd, yyyy') => {
    const formatedDateYYYYMMDD = formatDateDDMMYYToYYYYMMDD(deliveryDate);

    if (formatedDateYYYYMMDD) {
        return format(new Date(formatedDateYYYYMMDD), formatDeliveryDate);
    }

    return deliveryDate;
};

export const getPmallShippingMethodDetails = (itemDetails) => {
    const attributes = itemDetails.deliveryInfo?.attributes || [];

    const pmallShippingDetails = {
        brandId: itemDetails?.product?.brandCode || '',
        shippingMethodId: itemDetails?.itemShipping?.deliveryMethod || '',
        title: getCartAttributeByNameAndReturnValue(attributes, 'title'),
        description: getCartAttributeByNameAndReturnValue(attributes, 'description'),
        displayDeliveryDate: getCartAttributeByNameAndReturnValue(attributes, 'displayDeliveryDate'),
        cartOrderDeliveryDate: getFormatedDeliveryDate(itemDetails?.deliveryInfo?.deliveryDate || ''),
        rushAvail: itemDetails?.product?.rushAvail || '',
        shippingExtra: itemDetails?.product?.shippingExtra || '',
        shippingExtraExpress: itemDetails?.product?.shippingExtraExpress || '',
    };

    if (pmallShippingDetails.description && pmallShippingDetails.description.indexOf('&lt;') >= 0) {
        pmallShippingDetails.description = pmallShippingDetails.description.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/\\/g, '');
    }

    return pmallShippingDetails;
};

// const formatDateToYYYYMMDD = (dateString) => {
//     if (dateString) {
//         const formatedDate = formatDateDDMMYYToYYYYMMDD(dateString);

//         // replace / to - eg: 2021/08/13 to 2021-08-13
//         return formatedDate.replace(/\//g, '-');
//     }

//     return '';
// };

export const getPmallShippingMethodUpdateCartPayload = (shippingMethod) => {
    const calendarDateType = 'on';
    const calendarStartDate = shippingMethod?.rangeStartDate || '';
    const deliveryDate = shippingMethod?.deliveryDate || '';
    const deliverySLA = shippingMethod?.shippingMethodCode || '';
    const shippingMethodTitle = shippingMethod?.shippingMethodName || '';
    const legacyId = shippingMethod?.legaceyShippingMethod || '';
    const displayDeliveryDate = shippingMethod.displayDeliveryDate !== 'false';
    const shippingMethodDescription = shippingMethod?.shippingMessage || '';

    const payload = {
        calendarDateType,
        calendarStartDate: format(new Date(calendarStartDate), 'MM/dd/yyyy HH:mm:ss'),
        deliveryDate: format(new Date(deliveryDate), 'MM/dd/yyyy HH:mm:ss'),
        deliverySLA,
        attributes: [
            {
                attributeName: 'title',
                attributeValue: shippingMethodTitle,
            },
            {
                attributeName: 'legacyId',
                attributeValue: legacyId,

            },
            {
                attributeName: 'displayDeliveryDate',
                attributeValue: displayDeliveryDate.toString(),
            },
            {
                attributeName: 'description',
                attributeValue: shippingMethodDescription,
            },
        ],
    };

    return payload;
};

export default {};
